const API_URL = process.env.REACT_APP_API_BASE_URL;

const login = () => `${API_URL}/login`;

const refreshToken = () => `${API_URL}/refresh-token`;

const changePassword = () => `${API_URL}/change-password`;

const forgotPassword = () => `${API_URL}/forgot-password`;

const getAgeGroups = () => `${API_URL}/partner-admin/master-data/AGE_GROUP`

const resetPassword = (token) =>
  `${API_URL}/reset-password/reset?token=${token}`;

const getHelpInfo = (userRole) =>
  `${API_URL}/super-admin/getHelpSection?userRole=${userRole}`;

const getFilteredHelpInfo = (userRole, searchKey) =>
  `${API_URL}/end-user/help-section/search/?userRole=${userRole}${searchKey ? `&text=${searchKey}` : ''}`

const postHelpInfo = () => `${API_URL}/super-admin/helpSection`;

const deleteHelp = (id) => `${API_URL}/super-admin/deleteHelpSection/${id}`;

const partnerDetails = () => `${API_URL}/super-admin/partner-details`;

const updateRestoreTime = (partnerId, thresholdValue) =>
  `${API_URL}/super-admin/updateThresholdDays/${partnerId}?deletionThresholdDays=${thresholdValue}`;

const updateOrganisationType = (partnerId, organisationType) =>
  `${API_URL}/super-admin/update-orgdetails/${partnerId}?type=${organisationType}`;

const replyEnduserFeedback = (replyId) =>
  // `${API_URL}/super-admin/end-user-feedback-reply/${replyId}`;
  `${API_URL}/super-admin/feedback-reply/${replyId}`;
// /feedback-reply/{feedbackId}

const replyOrgFeedback = (feedbackId) =>
  `${API_URL}/super-admin/feedback-reply/${feedbackId}`;
// `${API_URL}/super-admin/org-feedback-reply/${feedbackId}`;

const replyPartnerFeedback = (feedbackId) =>
  `${API_URL}/super-admin/feedback-reply/${feedbackId}`;
// `${API_URL}/super-admin/partner-feedback-reply/${feedbackId}`;

const addPartner = () => `${API_URL}/super-admin/add-partner`;

const getPartners = (boolaf, boolgl, boolms, booltz, af, gl, ms, tz) =>
  `${API_URL}/super-admin/filterByPartner/?${boolaf ? `alphabeticRanges=${af}&` : ""
  }${boolgl ? `alphabeticRanges=${gl}&` : ""}${boolms ? `alphabeticRanges=${ms}&` : ""
  }${booltz ? `alphabeticRanges=${tz}&` : ""}`;

const searchPartner = (value) =>
  `${API_URL}/super-admin/filterByPartner/?searchText=${value}`;

const deletePartner = (partnerId) =>
  `${API_URL}/super-admin/partner/${partnerId}`;

/** Secure deletion: request OTP for an entity (e.g. PARTNER) */
const confirmEntityDeletion = (entity) =>
  `${API_URL}/confirm-entity-deletion?entity=${encodeURIComponent(entity)}`;

/** Secure deletion: verify OTP (otp as query param) */
const verifyDeleteOtp = (otp) =>
  `${API_URL}/verify-otp?otp=${encodeURIComponent(otp)}`;

const getOrgUnderPartner = (
  pageSize,
  pageNumber,
  partnerId,
  isActiveMember,
  boolaforg,
  boolglorg,
  boolmsorg,
  booltzorg,
  aforg,
  glorg,
  msorg,
  tzorg,
  value
) =>
  `${API_URL}/super-admin/partner/getAllOrganization?partnerId=${partnerId}&isActiveMember=${!isActiveMember}&${pageSize ? `pageSize=${pageSize}&` : ""
  }${pageNumber ? `pageNumber=${pageNumber}&` : ""}${boolaforg ? `range=${aforg}&` : ""
  }${boolglorg ? `range=${glorg}&` : ""}${boolmsorg ? `range=${msorg}&` : ""}${booltzorg ? `range=${tzorg}&` : ""
  }${value ? `search=${value}&` : ""}`;

const downloadEngagementCSV = (
  partnerId,
  ageId,
  profId,
  filterType,
  year,
  month,
  quarter
) =>
  `${API_URL}/super-admin/downloadCSV?partnerId=${partnerId}${ageId ? `&ageGroupId=${ageId}` : ""
  }${profId ? `&tagId=${profId}` : ""}${filterType ? `&filterType=${filterType}` : ""
  }${year ? `&year=${year}` : ""}${month ? `&month=${month}` : ""}${quarter ? `&quarter=${quarter}` : ""
  }`;

const getAllFeedback = () => `${API_URL}/super-admin/getAllFeedBack`;

const getAllFeedbackWithRole = (userRole) => `${API_URL}/super-admin/getAllFeedback/${userRole}`;

const getFeedbackSearch = (userRole, searchTerm) =>
  // `${API_URL}/super-admin/feedback-search?${`text=${encodeURIComponent(searchTerm)}`}`;
  `${API_URL}/super-admin/search-feedback/${userRole}?text=${encodeURIComponent(searchTerm)}`;

const downloadFeedback = (feedbackId) =>
  `${API_URL}/super-admin/downloadFeedback/${feedbackId}`;

const getSoftDelPartner = (searchTerm, boolAF, boolGL, boolMS, boolTZ, af, gl, ms, tz) =>
  `${API_URL}/super-admin/filter-restore-Partner/?${searchTerm !== '' ? `searchText=${encodeURIComponent(searchTerm)}&` : ''}${boolAF ? `alphabeticRanges=${af}&` : ""
  }${boolGL ? `alphabeticRanges=${gl}&` : ""}${boolMS ? `alphabeticRanges=${ms}&` : ""
  }${boolTZ ? `alphabeticRanges=${tz}` : ""}`;

const restorePartner = (partnerId) =>
  `${API_URL}/super-admin/recover/${partnerId}`;

const getEngagementData = (
  partnerID,
  ageID,
  profID,
  filterType,
  year,
  month,
  quarter
) =>
  `${API_URL}/super-admin/totalUsersByLocationAndCategory${partnerID ? `?partnerId=${partnerID}` : ""
  }${ageID ? `&ageGroupId=${ageID}` : ""}${profID ? `&tagId=${profID}` : ""}${filterType ? `&filterType=${filterType}` : ""
  }${year ? `&year=${year}` : ""}${month ? `&month=${month}` : ""}${quarter ? `&quarter=${quarter}` : ""
  }`;

const getProfessions = (ageGroupID) =>
  // `${API_URL}/super-admin/end-user-tags/age-group/${ageGroupID}`;
  `${API_URL}/partner-admin/master-data/age-tag-by-age-group/${ageGroupID}`;

const deleteSelectedOrgType = (partnerId, organizationType) =>
  `${API_URL}/super-admin/${partnerId}/deleteOrganizationType?organizationType=${organizationType}`;

const deleteFeedback = (feedbackId) =>
  `${API_URL}/super-admin/deleteFeedback/${feedbackId}`;

const viewFeedback = (feedbackId) =>
  `${API_URL}/super-admin/viewFile/${feedbackId}`;

const getAllSectors = (partnerId) =>
  // `${API_URL}/sector/get-all-sectors/${partnerId}`;
  `${API_URL}/super-admin/sector/${partnerId}?masterDataEnum=SECTOR`;

const getAllSubSectors = (sectorId) =>
  `${API_URL}/super-admin/get/sub-sector/${sectorId}?masterDataEnum=SUB_SECTOR`;


const postsectorSubsector = () => `${API_URL}/super-admin/add-sector`;

const updatesectorSubsector = (sectorId, partnerId) =>
  // `${API_URL}/super-admin/update-sector/${sectorId}`;
  `${API_URL}/super-admin/add-subsector/${sectorId}/${partnerId}`;

const deleteSector = (sectorId) =>
  // `${API_URL}/super-admin/delete-sector?${sectorId ? `sectorId=${sectorId}&` : ""}`;
  `${API_URL}/super-admin/delete/${sectorId}`;

const deleteSubsector = (subsectorId) =>
  // `${API_URL}/super-admin/delete-sector?${subsectorId ? `subsectorId=${subsectorId}` : ""}`;
  `${API_URL}/super-admin/delete/sub-sector/${subsectorId} `

const deleteAllSectors = (partnerId) => `${API_URL}/super-admin/delete-all-sectors-sub-sectors/${partnerId} `
const deleteAllSubSectors = (sectorId) => `${API_URL}/super-admin/delete-all-sub-sectors?sectorId=${sectorId} `


const postOrganisationType = (partnerId) =>
  `${API_URL}/super-admin/add/${partnerId}`;

const postPartnerType = (partnerId) =>
  `${API_URL}/super-admin/add/${partnerId}`;

const postAddOrganisationOrPartnerType = (partnerId) =>
  `${API_URL}/super-admin/add/${partnerId}`;

const putEditOrganisationOrPartnerType = (partnerId) =>
  `${API_URL}/super-admin/master-data/update/${partnerId}`;


const getAllOrganizationTypes = (partnerId) =>
  `${API_URL}/super-admin/master-data/get/${partnerId}?type=ORGANIZATION_TYPE`;

const getAllPartnerTypes = (partnerId, toggle) => `${API_URL}/super-admin/master-data/get/${partnerId}?type=PARTNER_TYPE`;

const getAllActivePartnerTypes = (partnerId) => `${API_URL}/super-admin/org-partner-types/${partnerId}/PARTNER_TYPE`;

const getAllActiveSalesTypes = (partnerId) => `${API_URL}/super-admin/org-partner-types/${partnerId}/SALES_TYPE`;
const getAllSalesTypes = (partnerId) => `${API_URL}/super-admin/master-data/get/${partnerId}?type=SALES_TYPE`;
const postSalesType = (partnerId) => `${API_URL}/super-admin/add/${partnerId}`;
const updateSalesType = (partnerId) => `${API_URL}/super-admin/master-data/update/${partnerId}`;
const deleteSalesType = (partnerTypeId) => `${API_URL}/super-admin/delete-partnerType/${partnerTypeId}`;


const deleteOrganisationType = (organisationTypeId) =>
  `${API_URL}/super-admin/delete-orgType/${organisationTypeId}`;

const deletePartnerType = (partnerTypeId) =>
  `${API_URL}/super-admin/delete-partnerType/${partnerTypeId}`;

const getPartnerPlans = (partnerId) => `${API_URL}/super-admin/fetch-partner-plans?partnerId=${partnerId}`;


const addPartnerPlans = () => `${API_URL}/super-admin/add-partner-plans`;
const updatePartnerPlans = () => `${API_URL}/super-admin/update-partner-plans`;


const downloadExcelTemplate = (templateEnum) => `${API_URL}/super-admin/downloadExcel-template?templateEnum=${templateEnum}`

const uploadExcelTemplate = (templateEnum, partnerId) => `${API_URL}/super-admin/upload/excel?partnerId=${partnerId}&templateEnum=${templateEnum}`
const uploadExcelDirectoryTemplate = (templateEnum, partnerId) => `${API_URL}/super-admin/companies/import?partnerId=${partnerId}&templateEnum=${templateEnum}`


const getAllProSettings = (partnerId) => {
  return `${API_URL}/super-admin/get-tabs-partner/${partnerId}`
}

const updateProSetting = (partnerId) => {
  return `${API_URL}/super-admin/update-tab/name/toggle`
}


const stripeSupportedCountries = () => {
  return `${API_URL}/super-admin/stripe-supported-countries`
}

const stripeSupportedCurrencies = (id) => {
  return `${API_URL}/super-admin/currencies?id=${id}`
}


const getDeletionThresholdDays = (partnerId) =>
  `${API_URL}/super-admin/get-deletionThresholdDays/${partnerId}`;

const fetchFreeTrialPeriod = (partnerId) =>
  `${API_URL}/super-admin/trial-period/${partnerId}`;

const updateSubscriptionTrialPeriod = (partnerId) =>
  `${API_URL}/super-admin/trial-period/${partnerId}`;

const uploadPoweredByLogo = (partnerId) =>
  `${API_URL}/super-admin/upload-powered-by-logo?partnerId=${partnerId}`;

const getPartnerDetails = (subDomainName) => `${API_URL}/end-user/partner-details?subDomainName=${subDomainName}`;

const footerDocumentsUpload = () => `${API_URL}/super-admin/upload-footer-documents`;
const fetchFooterDocuments = (partnerId) => `${API_URL}/end-user/${partnerId}/footer-documents`;
const deleteFooterDocument = (partnerId, documentId) => `${API_URL}/super-admin/${partnerId}/footer-documents?documentIds=${documentId}`;

const userServiceApi = {
  login,
  refreshToken,
  changePassword,
  forgotPassword,
  getAgeGroups,
  resetPassword,
  getHelpInfo,
  getFilteredHelpInfo,
  postHelpInfo,
  deleteHelp,
  partnerDetails,
  updateRestoreTime,
  updateSubscriptionTrialPeriod,
  updateOrganisationType,
  replyEnduserFeedback,
  addPartner,
  getPartners,
  deletePartner,
  confirmEntityDeletion,
  verifyDeleteOtp,
  getOrgUnderPartner,
  downloadEngagementCSV,
  searchPartner,
  getAllFeedback,
  getFeedbackSearch,
  downloadFeedback,
  replyOrgFeedback,
  replyPartnerFeedback,
  getSoftDelPartner,
  restorePartner,
  getEngagementData,
  getProfessions,
  deleteFeedback,
  viewFeedback,
  deleteSelectedOrgType,
  getAllSectors,
  getAllSubSectors,
  postsectorSubsector,
  updatesectorSubsector,
  deleteSector,
  deleteSubsector,
  postOrganisationType,
  postAddOrganisationOrPartnerType,
  postPartnerType,
  getAllOrganizationTypes,
  getAllPartnerTypes,
  deleteOrganisationType,
  deletePartnerType,
  getPartnerPlans,
  addPartnerPlans,
  updatePartnerPlans,
  downloadExcelTemplate,
  uploadExcelTemplate,
  uploadExcelDirectoryTemplate,
  putEditOrganisationOrPartnerType,
  getAllProSettings,
  updateProSetting,
  getDeletionThresholdDays,
  stripeSupportedCountries,
  getAllFeedbackWithRole,
  fetchFreeTrialPeriod,
  uploadPoweredByLogo,
  getPartnerDetails,
  footerDocumentsUpload,
  fetchFooterDocuments,
  deleteFooterDocument,
  deleteAllSectors,
  deleteAllSubSectors,
  getAllSalesTypes,
  postSalesType,
  updateSalesType,
  deleteSalesType,
  getAllActivePartnerTypes,
  getAllActiveSalesTypes,
  stripeSupportedCurrencies
};

export default userServiceApi;
